// project hash key
// e921d896b24ee51ad95dc303a034758da1187532b0a44189bd99aa333255781b

import { RANK_NAME } from '../constants';

export const setBackGroundLineUp = (rankName) => {
  let result = {
    color: '',
    background: '',
  };
  switch (rankName) {
    case RANK_NAME.rankA:
      result = {
        color: 'my-color-dark-red',
        background: 'my-bg-dark-red',
      };
      break;
    case RANK_NAME.rankB:
      result = {
        color: 'my-color-blue-600',
        background: 'my-bg-blue-600',
      };
      break;
    case RANK_NAME.rankC:
      result = {
        color: 'my-dark-green',
        background: 'my-bg-dark-green',
      };
      break;
    case RANK_NAME.rankD:
      result = {
        color: 'my-cerise-pink',
        background: 'my-bg-cerise-pink',
      };
      break;
    case RANK_NAME.rankE:
      result = {
        color: 'my-water-blue',
        background: 'my-bg-water-blue',
      };
      break;
    case RANK_NAME.rankF:
      result = {
        color: 'my-color-orange-500',
        background: 'my-bg-orange-500',
      };
      break;
    case RANK_NAME.rankG:
      result = {
        color: 'my-color-purple-500',
        background: 'my-bg-purple-500',
      };
      break;
    default:
      break;
  }
  return result;
};
